import { FieldSwitch } from "@qw/ui";
import type { FC } from "react";
import { useFormContext } from "react-hook-form";

import type { ProductFormValues } from "./product-form.types";

export const EnabledSwitch: FC<{ canEdit?: boolean }> = ({ canEdit = true }) => {
  const { watch } = useFormContext<ProductFormValues>();
  const enabled = watch("enabled");

  return <FieldSwitch label={enabled ? "Enabled" : "Disabled"} name="enabled" disabled={!canEdit} />;
};
